export interface Product {
  id: string
  slug: string
  name: string
  description: string
  price: number
  category: string
  images: string[]
  sizes?: string[]
  colors?: { name: string; hex: string }[]
  inStock: boolean
  featured?: boolean
}

export const products: Product[] = [
  {
    id: "1",
    slug: "gnl-logo-tee",
    name: "GNL Logo Tee",
    description: "Classic cotton tee with the GameNight League logo. Soft, comfortable, and perfect for game nights.",
    price: 28,
    category: "Apparel",
    images: ["/images/merch/logo-tee.jpg"],
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "Navy", hex: "#1e3a5f" },
      { name: "Charcoal", hex: "#36454f" }
    ],
    inStock: true,
    featured: true
  },
  {
    id: "2",
    slug: "controller-hoodie",
    name: "Controller Hoodie",
    description: "Premium heavyweight hoodie with embroidered controller design. Stay cozy during late night sessions.",
    price: 55,
    category: "Apparel",
    images: ["/images/merch/controller-hoodie.jpg"],
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "Heather Gray", hex: "#9ca3af" }
    ],
    inStock: true,
    featured: true
  },
  {
    id: "3",
    slug: "player-dad-hat",
    name: "Player Dad Hat",
    description: "Relaxed fit dad hat with \"PLAYER\" embroidery. Adjustable strap for perfect fit.",
    price: 24,
    category: "Accessories",
    images: ["/images/merch/dad-hat.jpg"],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "Navy", hex: "#1e3a5f" },
      { name: "Olive", hex: "#556b2f" }
    ],
    inStock: true
  },
  {
    id: "4",
    slug: "gnl-mousepad-xl",
    name: "GNL Mousepad XL",
    description: "Extended gaming mousepad with stitched edges. 900x400mm surface fits your full setup.",
    price: 32,
    category: "Gear",
    images: ["/images/merch/mousepad.jpg"],
    inStock: true,
    featured: true
  },
  {
    id: "5",
    slug: "league-champion-tee",
    name: "League Champion Tee",
    description: "Exclusive tee for league champions. Show off your victory with this limited design.",
    price: 35,
    category: "Apparel",
    images: ["/images/merch/champion-tee.jpg"],
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: [
      { name: "Gold", hex: "#d4af37" }
    ],
    inStock: false
  },
  {
    id: "6",
    slug: "gnl-sticker-pack",
    name: "GNL Sticker Pack",
    description: "Set of 6 vinyl stickers featuring GNL logos and gaming designs. Waterproof and durable.",
    price: 12,
    category: "Accessories",
    images: ["/images/merch/stickers.jpg"],
    inStock: true
  },
  {
    id: "7",
    slug: "cozy-joggers",
    name: "Cozy Joggers",
    description: "Ultra-soft joggers with tapered fit. Perfect for gaming or lounging.",
    price: 48,
    category: "Apparel",
    images: ["/images/merch/joggers.jpg"],
    sizes: ["S", "M", "L", "XL"],
    colors: [
      { name: "Black", hex: "#1a1a1a" },
      { name: "Charcoal", hex: "#36454f" }
    ],
    inStock: true
  },
  {
    id: "8",
    slug: "ceramic-mug",
    name: "GNL Ceramic Mug",
    description: "15oz ceramic mug with wrap-around design. Microwave and dishwasher safe.",
    price: 18,
    category: "Accessories",
    images: ["/images/merch/mug.jpg"],
    inStock: true
  }
]

export const categories = ["All", "Apparel", "Accessories", "Gear"]
